/**
 * 
 */
export default class RestApi {
  auth = {
    login: (data) => $app.api.post([ 'auth/login', ]).data(data),
    loginByCode: (data) => $app.api.post([ 'auth/login/by-code', ]).data(data),
    info: () => $app.api.get([ 'auth/info', ]),
    register: (data) => $app.api.post([ 'auth/register', ]).data(data),
    sendCode: (data) => $app.api.post([ 'auth/send-code', ]).data(data),
    recover: (data) => $app.api.post([ 'auth/recover', ]).data(data),
  }
  
  wantedTime = {
    getMyOne: () => $app.api.get([ 'my-wanted-time', ]),
    getMy: () => $app.api.get([ 'my-wanted-times', ]),
    create: (data) => $app.api.post([ 'wanted-times', ]).data(data),
  }

  hrRequests = {
    getMy: (status) => {
      const api = $app.api.get([ 'me/hr-requests', ])
      return status && status !== 'all' ? api.query('status='+encodeURIComponent(status)) : api
    },
    getOptions: () => $app.api.get([ 'me/hr-request-options', ]),
    create: (data) => {
      const formData = new FormData()
      $n.each(data, (value, name) => {
        if (value !== null && value !== undefined && value !== '') {
          formData.append(name, value)
        }
      })
      return $app.api.post([ 'me/hr-requests', ])
        .data(formData)
        .config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
  }
  

  news = {
    get: (id) => $app.api.get([ 'news*', id, ]),
    getLike: (id) => $app.api.get([ 'news*/likes', id, ]),
    setLike: (id, data) => $app.api.post([ 'news*/like', id, ]).data(data),
  }

  achievements = {
    getAll: () => $app.api.get([ 'achievements', ]),
    getDesk: () => $app.api.get([ 'desk/achievements/users', ]),
    getUserAchievements: (id) => $app.api.get([ 'users*/achievements', id, ]),
  }
  
  products = {
    get: (id) => $app.api.get([ 'products*', id, ]),
  }
  
  favorites = {
    get: () => $app.api.get([ 'favorites', ]),
    addToFav: (id) => $app.api.post([ 'products*/favorite', id, ] ),
    removeFav: (id) => $app.api.delete([ 'products*/favorite', id, ]),
  }
  
  comments = {
    create: (id, data) => $app.api.post([ 'products*/comments', id, ]).data(data),
  }
  sos = {
    create: (data) => $app.api.post([ 'sos-mobile', ]).data(data),
  }
  
  results = {
    getUserResults: () => $app.api.get([ 'kln/user/results', ]).all(),
    postUserResults: (data) => $app.api.post([ 'all/user/results', ]).all().data(data),

    get: (id) => $app.api.get([ 'kln/results*', id, ] ),
    patch: (id, data) => $app.api.patch([ 'kln/results*', id, ]).data(data),
  }
  timerresults = {
    get: (id) => $app.api.get([ 'kln/timer-results*', id, ] ),
    patch: (id, data) => $app.api.patch([ 'kln/timer-results*', id, ]).data(data),
  }

  formpmresults = {
    get: (id) => $app.api.get([ 'form-pm-results*/one', id, ]),
    patch: (id, data) => $app.api.patch([ 'form-pm-results*', id, ]).data(data),
  }
  formpm = {
    get: (id) => $app.api.get([ 'form-pm-categories*', id, ]),
    getAll: () => $app.api.get([ 'form-pm-categories', ]),
    edit: (id, data) => $app.api.patch([ 'form-pm-categories*', id, ]).data(data),
    create: (data) => $app.api.post([ 'form-pm-categories', ]).data(data),
    delete: (id) => $app.api.delete([ 'form-pm-categories*', id, ]),
  }
  formpmsections = {
    get: (id) => $app.api.get([ 'form-pm-sections*/one', id, ]),
    getAll: (id) => $app.api.get([ 'form-pm-sections*', id, ]),
    edit: (id, data) => $app.api.patch([ 'form-pm-sections*', id, ]).data(data),
    create: (data) => $app.api.post([ 'form-pm-sections', ]).data(data),
    delete: (id) => $app.api.delete([ 'form-pm-sections*', id, ]),
  }
  formpmquestions = {
    get: (id) => $app.api.get([ 'form-pm-questions*/one', id, ]),
    getAll: (id) => $app.api.get([ 'form-pm-questions*', id, ]),
    edit: (id, data) => $app.api.patch([ 'form-pm-questions*', id, ]).data(data),
    create: (data) => $app.api.post([ 'form-pm-questions', ]).data(data),
    delete: (id) => $app.api.delete([ 'form-pm-questions*', id, ]),
  }
  quizzes = {
    get: (categoryId) => $app.api.get([ 'kln/categories*/quizzes', categoryId, ]).all(),
  }

  categories = {
    get: (id) => $app.api.get([ 'categories*', id, ]).all(),
  }

  questions = {
    get: (id) => $app.api.get([ 'kln/quizzes*/questions', id, ]).all(),
  }

  timerquizzes = {
    get: (categoryId) => $app.api.get([ 'kln/timer-categories*/timer-quizzes', categoryId, ]).all(),
  }

  timercategories = {
    get: (id) => $app.api.get([ 'timer-categories*', id, ]).all(),
  }

  timerquestions = {
    get: (id) => $app.api.get([ 'kln/timer-quizzes*/timer-questions', id, ]).all(),
  }

  orders = {
    create: (data) => $app.api.post([ 'orders', ]).data(data),
    getMy: () => $app.api.get([ 'my/orders', ]),
    get: (id) => $app.api.get([ 'orders*', id, ]),
    edit: (id, data) => $app.api.patch([ 'orders*', id, ]).data(data),
  }
  
  user = {
    edit: (id, data) => $app.api.patch([ 'users*', id, ]).data(data),
    deleteAcc: (id) => $app.api.post([ 'users*/delete-acc', id, ]),
    sendEmailCode: () => $app.api.post([ 'email/code', ]),
    editEmail: (id, data) => $app.api.patch([ 'users*/email', id, ]).data(data),
    checkIin: (data) => $app.api.post([ 'check-iin', ]).data(data),
  }
  
  files = {
    create: (data) => {
      const formData = new FormData()
      $n.each(data, (value, name) => {
        formData.append(name, value)
      })
      return $app.api.post([ 'files', ]).data(formData).config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
    getDocs: (userId) => $app.api.get([ 'files/users*', userId, ]),
  }
  aims = {
    getMonth: () => $app.api.get([ 'month/aims', ]),
  }
  
  notifications = {
    get: () => $app.api.get([ 'user/notifications', ]),
    getNotRead: () => $app.api.get([ 'user/notifications/not-read', ]),
  }

  transactions = {
    get: () => $app.api.get([ 'user/transactions', ]),
  }


  library = {
    get: (id) => $app.api.get([ 'library*', id, ]),
    getByCategory: (categoryId) => $app.api.get([ 'library-categories*/library', categoryId, ]),
    getCategories: (id) => $app.api.get([ 'library-categories*', id, ]),
  }
  biots = {
    getList: () => $app.api.get([ 'get-biot-list', ]),
    get: (id) => $app.api.get([ 'biot-tests*', id, ]),
    getResults: () => $app.api.get([ 'biot-results-my', ]),
    getResult: (id) => $app.api.get([ 'biot-results*', id, ]),
    save: (data) => $app.api.post([ 'biot-results', ]).data(data),
  }

  schedule = {
    mySchedule: (data) => $app.api.post([ 'my/schedule', ]).data(data),
  }
}
